import {useCallback, useState} from 'react'

export const useSelectPlaylists = (): {
  selected: string[]
  addPlaylist: (id: string) => void
  removePlaylist: (id: string) => void
  reset: () => void
} => {
  const [playlists, setPlaylists] = useState<string[]>([])

  const addPlaylist = (id: string) => {
    if (playlists.includes(id)) return
    setPlaylists(p => [...p, id])
  }

  const removePlaylist = useCallback((id: string) => {
    setPlaylists(p => p.filter(playlist => playlist !== id))
  }, [])

  const reset = useCallback(() => setPlaylists([]), [])

  return {selected: playlists, addPlaylist, removePlaylist, reset}
}
